import axios from 'axios'
import {getBaseUrl} from "./BaseService"

axios.defaults.withCredentials = true

/**
 * The PayPal Web SDK v6 boots with the partner client id paga-paypal owns, so nothing on the
 * page can render until this resolves.
 */
export async function getPaypalClientId() {
    const response = await axios.get(getBaseUrl() + "/paypal/client-id")
    return response.data.clientId
}

/**
 * Creates the PayPal order every payment session on this page pays against — the wallet
 * buttons, the embedded card fields and the Google/Apple Pay sheets all funnel through here.
 *
 * Returns the {orderId} shape the v6 session APIs expect from a createOrder callback.
 */
export async function createPaypalOrder(orderRequest) {
    const response = await axios.post(getBaseUrl() + "/paypal/orders", orderRequest)
    const order = response.data

    if (!order?.id) {
        throw new Error(order?.details?.[0]?.description || 'PayPal did not return an order id')
    }

    return {orderId: order.id}
}

/**
 * Captures an approved order and returns its capture, throwing when PayPal reports anything
 * other than a captured/authorized payment so the caller can surface the failure.
 */
export async function capturePaypalOrder(orderId) {
    const response = await axios.post(`${getBaseUrl()}/paypal/orders/${orderId}/capture`)
    const order = response.data

    const transaction =
        order?.purchase_units?.[0]?.payments?.captures?.[0] ||
        order?.purchase_units?.[0]?.payments?.authorizations?.[0]

    if (!transaction || transaction.status === 'DECLINED') {
        throw new Error(
            transaction
                ? `Transaction ${transaction.status}`
                : order?.details?.[0]?.description || 'Payment could not be completed'
        )
    }

    return transaction
}
